import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "col-6" };
const _hoisted_2 = { class: "col-6" };
const _hoisted_3 = ["onUpdate:modelValue"];
const _hoisted_4 = /*#__PURE__*/ _createTextVNode(" Update DMX Channels ");
import { ref, watch } from 'vue';
import Button from '@/components/UI/Button/Button.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        status: null
    },
    emits: ["updateDMX"],
    setup(__props, { emit }) {
        const props = __props;
        const currentStatus = ref([]);
        currentStatus.value = JSON.parse(JSON.stringify(props.status));
        watch(() => props.status, (newStatus) => {
            if (currentStatus.value.length === 0) {
                currentStatus.value = newStatus;
            }
        });
        function updateChannels() {
            emit('updateDMX', { name: 'dmx', value: JSON.stringify(currentStatus.value) });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentStatus.value, (channel, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: "row",
                        key: index
                    }, [
                        _createElementVNode("div", _hoisted_1, " Channel " + _toDisplayString(channel.channel) + ": ", 1),
                        _createElementVNode("div", _hoisted_2, [
                            _withDirectives(_createElementVNode("input", {
                                type: "number",
                                "onUpdate:modelValue": ($event) => ((channel.value) = $event),
                                class: "form-control"
                            }, null, 8, _hoisted_3), [
                                [_vModelText, channel.value]
                            ])
                        ])
                    ]));
                }), 128)),
                _createVNode(Button, {
                    onClick: updateChannels,
                    class: "mt-3 btn btn-primary"
                }, {
                    default: _withCtx(() => [
                        _hoisted_4
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
